import axios from 'axios';
import { getTokenCredentials } from '../../../Shared/functions';
import { BASE_API } from '../../../Shared/Constants';


export function getTreasury() {
    return axios.post(BASE_API + 'api/treasury', {}, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        throw error.response.data.message;
    });
}

export function getExcel(body){
    return axios.post(BASE_API + 'api/treasury/paymentexcel', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        throw error.response.data.message;
    });
}

export function getPaymentList(body){
    return axios.post(BASE_API + 'api/payment/getlist', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
        throw error.response.data.message;
    });
}

export function getRecaudation(body){
    return axios.post(BASE_API + 'api/treasury/collection', body, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        console.log(error);
        throw error.response.data.message;
    });
}

export function getDetailFine(body){
    return axios.post(BASE_API + 'api/fine/getlist', body , {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic '+getTokenCredentials()
        }
    })
    .then(response => {return response})
    .catch(error => {
        if(error.error === -100) {
            return []
        }
    }); 
}